export class Checkbox {

    constructor (private checkboxContainer:JQuery) {
        checkboxContainer.on("change",(ev,extraParameters)=>this.changeEvent(ev,extraParameters));
        checkboxContainer.on("keydown",(ev)=>this.keyEvent(ev));
        this.syncWidget();
    }

    private syncWidget() {
        let cb=this.checkboxContainer.find('input[type="checkbox"]');
        let isChecked=cb.prop('checked');
        this.checkboxContainer.toggleClass('checked',isChecked??false);
        this.checkboxContainer.attr('aria-checked',isChecked?'true':'false');
    }

    private changeEvent(ev:JQuery.TriggeredEvent, extraParameters:any) {
        if ((typeof extraParameters=='object') && extraParameters.internal) return;
        this.syncWidget();
    }

    private keyEvent(ev:JQuery.TriggeredEvent) {
        if(ev.key != "Enter" && ev.key != " ") return;
        ev.preventDefault();
        let cb=this.checkboxContainer.find('input[type="checkbox"]');
        cb.prop('checked',!cb.prop('checked'));
        this.syncWidget();
        cb.trigger("change",{internal:true});
    }

}

export {};